import React, { useEffect, useReducer } from 'react';

// CSS
import styles from './LoggerStatus.scss';

// MANAGERS
import { Logger, LoggerLevel, LoggerSource, LoggerTarget, TLoggerState } from '@Managers/Logger';

function LoggerLogs() {
    const [state, setState] = useReducer(
        (
            state: {
                logLevels: Array<{ name: string; value: { console: boolean; kibana: boolean } }>;
                logSource: Array<{ name: string; value: { console: boolean; kibana: boolean } }>;
            },
            newState: any
        ) => ({ ...state, ...newState }),
        {
            logLevels: [],
            logSource: []
        }
    );

    useEffect(() => {
        updateData(Logger.getState());
    }, []);

    function updateData(data: TLoggerState) {
        setState({
            logLevels: Object.entries(data.levels).map(([key, value]) => ({ name: key, value })),
            logSource: Object.entries(data.sources).map(([key, value]) => ({ name: key, value }))
        });
    }

    function checkbox(evt: React.ChangeEvent<HTMLInputElement>, category: keyof TLoggerState, name: string, target: LoggerTarget) {
        updateData(
            Logger.setState({
                category,
                key: name as LoggerLevel | LoggerSource,
                target,
                value: evt.target.checked
            })
        );
    }

    return (
        <div className={styles.logger_groups_container}>
            <div>
                <div>Source Logs</div>
                <div>
                    {state.logSource.map((item, key) => (
                        <div key={key} className={styles.logger_group_item}>
                            <div className={styles.label}>{item.name}: </div>

                            <div className={styles.input}>
                                <input
                                    type="checkbox"
                                    onChange={(evt) => checkbox(evt, 'sources', item.name, LoggerTarget.CONSOLE)}
                                    checked={item.value.console}
                                />
                                <span className={`${item.value.console ? styles['con-true'] : styles['con-false']}`}>Console</span>
                            </div>

                            <div className={styles.input}>
                                <input
                                    type="checkbox"
                                    onChange={(evt) => checkbox(evt, 'sources', item.name, LoggerTarget.KIBANA)}
                                    checked={item.value.kibana}
                                />
                                <span className={`${item.value.kibana ? styles['con-true'] : styles['con-false']}`}>Kibana</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div>
                <div className={styles.logger_group_item}>
                    <div className={styles.label}>Level</div>
                    <div className={styles.input}>Console</div>
                    <div className={styles.input}>Kibana</div>
                </div>

                {state.logLevels.map((item, key) => (
                    <div key={key} className={styles.logger_group_item}>
                        <div className={styles.label}>{item.name}</div>

                        <div className={styles.input}>
                            <input type="checkbox" onChange={(evt) => checkbox(evt, 'levels', item.name, LoggerTarget.CONSOLE)} checked={item.value.console} />
                            <span className={`${item.value.console ? styles['con-true'] : styles['con-false']}`}>Console</span>
                        </div>

                        <div className={styles.input}>
                            <input type="checkbox" onChange={(evt) => checkbox(evt, 'levels', item.name, LoggerTarget.KIBANA)} checked={item.value.kibana} />
                            <span className={`${item.value.kibana ? styles['con-true'] : styles['con-false']}`}>Kibana</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default LoggerLogs;
